import React from 'react';
import './Timer.scss';

const Timer = props => {
  const timerItems = [];

  for (let i = props.totalTime; i > 0; i--) {
    let className = '';
    if (i > props.timeLeft) {
      if (i <= 10) {
        className = 'item-red';
      } else {
        className = 'item-green';
      }
    }
    timerItems.push(<div key={i} className={'Timer-item ' + className}></div>);
  }

  return (
    <div className='Timer'>
      <div className='Timer-items'>
        {timerItems}
      </div>
      <div className='Timer-counter'>{props.timeLeft}</div>
    </div>
  );
};

export default Timer;
